import { useGcsStore } from '../../../store/useGcsStore';
import { type MissionId } from '../../../types/gcs/mission';
import { DeliveryPointMarker } from './markers/DeliveryPointMarker';
import { PickupPointMarker } from './markers/PickupPointMarker';

interface SingleMissionPointMarkersProps {
  gcsId: string;
  missionId: MissionId;
}

export const SingleMissionPointMarkers = ({ gcsId, missionId }: SingleMissionPointMarkersProps) => {
  const liveMission = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    return Array.from(gcsData?.liveMissionsMap.values() ?? []).find((mission) => mission.missionId === missionId);
  });

  if (!liveMission) {
    return null;
  }

  return (
    <>
      <DeliveryPointMarker key={`${missionId}-delivery`} deliveryPoint={liveMission.package.order.deliveryPoint} />
      {liveMission.pickupPoint && (
        <PickupPointMarker key={`${missionId}-pickup`} pickupPoint={liveMission.pickupPoint} />
      )}
    </>
  );
};
